export const getDeviceTypeName = (deviceTypeName: string): string => {
  const name = deviceTypeName.toLowerCase();

  switch (name) {
    case 'cell phone':
      return 'Phone';
    case 'other':
      return 'Other device';
    default:
      return deviceTypeName;
  }
};
